import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
  loading: false,
  data: [],
};

export default createReducer(initialState)({
  [types.DAILY_CHECK_IN_LIST_HISTORY]: (state, action) => ({
    ...state,
    listHistory: action.payload,
  }),
  [types.DAILY_CHECK_IN_LIST_RULE_SETTING]: (state, action) => ({
    ...state,
    listRuleSetting: action.payload,
  }),
  [types.DAILY_CHECK_IN_UPDATE_RULE_SETTING]: (state, action) => ({
    ...state,
    updateRuleSetting: action.payload,
  }),
});

